import ResultsInnovation from './resultsInnovation.js';
export default ResultsInnovation;
